function OfferButton({ onClick }) {
  return (
    <>
      <style>{`
        @keyframes rotateCircle {
          0% { transform: rotate(0deg) scale(1); }
          50% { transform: rotate(180deg) scale(1.05); }
          100% { transform: rotate(360deg) scale(1); }
        }

        .animate-rotateCircle {
          animation: rotateCircle 6s linear infinite !important;
        }
      `}</style>

      <button
        id="special-offers-fab"
        onClick={onClick}
        className="
          w-20 h-20
          rounded-full
          flex items-center justify-center
          relative
        "
      >
        {/* Rotating Background */}
        <div
          className="
            absolute inset-0 
            rounded-full 
            bg-[url('/public/images/bg.png')] 
            bg-cover bg-center
            animate-rotateCircle
            opacity-80
            w-24
          "
        ></div>

        {/* Ping Glow */}
        <span className="absolute inline-flex w-20 h-20 animate-ping rounded-full"></span>

        {/* Offer Image */}
        <img
          src="/images/offer_3.png"
          alt="Offer"
          className="
            relative z-10
            w-18 object-contain
            drop-shadow-[0_6px_6px_rgba(0,0,0,0.35)]
            hover:translate-y-[-4px] hover:scale-[1.05]
          "
        />
      </button>
    </>
  );
}

export default OfferButton;
